/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import { useCallback, useEffect, useState } from 'react';
import { Input, InputAdornment } from 'tdesign-react';

import { Replace } from '@/components/icon';
import { IReplaceMsgTextInfo } from '@/store/modules/__endpoints__/module';

import styles from './index.module.less';

interface IProps {
  onChange: (value: IReplaceMsgTextInfo) => void;
  value: IReplaceMsgTextInfo;
  disabled: boolean;
}

const ItemComp: React.FC<IProps> = (props) => {
  const { value, disabled, onChange } = props;

  const [val, setVal] = useState<IReplaceMsgTextInfo>({ old: '', new: '', type: 2 });
  useEffect(() => {
    setVal(value);
  }, [value]);


  const handleChange1 = useCallback((val: string) => {
    setVal(pre => ({
      ...pre,
      old: val,
    }));
    onChange({ ...value, old: val });
  }, [value, onChange]);

  const handleChange2 = useCallback((val: string) => {
    setVal(pre => ({
      ...pre,
      new: val,
    }));
    onChange({ ...value, new: val });
  }, [value, onChange]);

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <InputAdornment prepend="命中" style={{ width: '100%', borderRadius: 5, overflow: 'hidden' }}>
          <Input value={val?.old} disabled={disabled} onChange={handleChange1} />
        </InputAdornment>
      </div>
      <Replace />
      <div className={styles.wrapper}>
        <InputAdornment prepend="替换" style={{ width: '100%', borderRadius: 5, overflow: 'hidden' }}>
          <Input value={val?.new} disabled={disabled} onChange={handleChange2} />
        </InputAdornment>
      </div>
    </div>
  );
};

export default ItemComp;
